import type {TestSmtpEmailCredentialsRequestBody} from '@dms/api/core';

import type {EmailServiceFormSchemaType} from '../types/EmailServiceFormSchemaType';

export function toSmtpCredentialsTestValues(
  values: Pick<EmailServiceFormSchemaType, 'host' | 'username' | 'password' | 'emailAddress'> & {
    port: number | string;
  }
): TestSmtpEmailCredentialsRequestBody {
  return {
    host: values.host,
    port: Number(values.port),
    username: values.username,
    password: values.password,
    emailAddress: values.emailAddress,
  };
}
